import React, { Component } from 'react';
import { TopBar, BannerProfessional } from '../layouts/home04';
import { Header, Footer, BottomBar , Loader} from '../layouts/general';
import { BannerTitle } from '../layouts/general/course';
import { ContentSingle } from '../layouts/course';
class SapAriba extends Component {
    constructor(props) {
        super(props);
        this.state = {
            headers: [
                {
                    id: 1,
                    names: 'Courses'
                }
            ],
            titleBanner: [
                {
                    id: '1',
                    classnames: 'flat-title-page parallax parallax11 style4',
                    classoverlay: 'overlay style4',
                    classbread: 'breadcrumbs',
                    titles:'Course Details',
                    description: 'All our courses are self-paced and have been designed by subject matter experts, to give you an interactive and enriched learning experience.',
                    name01: 'Home', 
                    name02: 'Courses',
                    link01: '/courses-single',
                    srcimg: 'images/title-page/bg-white.png',

                }
            ]
        }
    }
    render() {
        return (
            <div className="bg-body">
                <div className="boxed">
                <Loader />
                    <TopBar />
                    {
                        this.state.headers.map(data => (
                            <Header data={data} key={data.id}/>
                        ))
                    }
                    {
                        this.state.titleBanner.map(data => (
                            <BannerTitle data={data} key={data.id}/>
                        ))
                    }
                    <ContentSingle />
                    <section className="flat-free-month parallax parallax15 style3">
                        <div className="container">
                            <BannerProfessional />
                        </div>
                    </section>
                    <Footer />
                    <BottomBar />
                </div> 
            </div>
        );
    }
}

export default SapAriba;